import React from 'react';
import PropTypes from 'prop-types';

import SaveButton from '../../../../../common/buttons/saveButton';
import shopifyIcon from '../../../../../../../images/shopifyIcon.png';

import PendingConnectionModal from '../../../../../common/PendingConnectionModal';
import ShopifyUrlField from './ShopifyUrlField';

const ConnectToShopify = ({ handleSubmit, invalid, openedIsOn }) => (
  <div className="connect-to-shopify">
    <img
      alt="shopify-logo"
      className="shopify-logo"
      src={shopifyIcon}
      role="presentation"
    />
    <form
      onSubmit={handleSubmit}
    >
      <h1>Shopify</h1>
      <h2>Connect Shopify to Squire to sync inventory and prices.</h2>
      <ShopifyUrlField />
      <div className="connect-to-shopify__footer">
        <SaveButton
          content="Connect"
          disabled={invalid}
        />
      </div>
    </form>
    <PendingConnectionModal
      display-if={openedIsOn}
      text="Please follow the steps in Shopify to complete your integration"
    />
  </div>
);

ConnectToShopify.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  openedIsOn: PropTypes.bool.isRequired,
};

export default ConnectToShopify;
